<div class="sidebar">
  <div class="sidebar-header">
    <button mat-icon-button (click)="onNew()" matTooltip="Nueva conversación">
      <mat-icon>add</mat-icon>
    </button>
  </div>
  <div class="conversation-list">
    <div
      *ngFor="let conv of conversations"
      class="conversation-item"
      [class.active]="conv.id === selectedConversationId"
      (click)="onSelect(conv.id)"
    >
      <div *ngIf="editingConversationId !== conv.id" class="conv-display">
        <span class="conv-title">{{ conv.title }}</span>
        <span class="conv-date">{{ conv.updated_at | date: 'short' }}</span>
        <button
          mat-icon-button
          class="rename-btn"
          (click)="onRename(conv, $event)"
          matTooltip="Renombrar"
        >
          <mat-icon class="rename-icon">edit</mat-icon>
        </button>
      </div>
      <div *ngIf="editingConversationId === conv.id" class="conv-edit">
        <input
          type="text"
          class="rename-input"
          [(ngModel)]="editingTitle"
          (keydown)="onRenameKeyDown(conv, $event)"
          maxlength="255"
        />
        <button
          mat-icon-button
          class="save-btn"
          (click)="saveRename(conv); $event.stopPropagation()"
        >
          <mat-icon class="save-icon">check</mat-icon>
        </button>
        <button
          mat-icon-button
          class="cancel-btn"
          (click)="cancelRename(); $event.stopPropagation()"
        >
          <mat-icon class="cancel-icon">close</mat-icon>
        </button>
      </div>
    </div>
    <div *ngIf="conversations.length === 0" class="no-conversations">No hay conversaciones</div>
  </div>
</div>
